import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

interface CircularLoadingProps {
    width?: string;
    height?: string;
    color?: string;
    visible?: boolean;
}

const CircularLoading: React.FC<CircularLoadingProps> = ({
    width = '125',
    height = '125',
    color = 'var(--primary-color)',
    visible = true,
}) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '30px 0px' }}>
            <ThreeDots
                height={height}
                width={width}
                color={color}
                radius={9}
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={visible}
            />
        </div>
    );
};

export default CircularLoading;